(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('chat', chat);

    chat.$inject = ['$http', '$q', 'endPoints', 'authorization', '$rootScope', 'audioService'];

    //Service for scope sharing between controllers
    function chat($http, $q, endPoints, authorization, $rootScope, audioService) {
        var service = {
            loadChat: loadChat,
            updateChat: updateChat,
            ackReceived: ackReceived,
            markAsRead: markAsRead,
            sendMessage: sendMessage,
            getNewMsgCount: getNewMsgCount,
            messages: null,
            operatorMessages: null,
            version: null,
            loadedInterval: null
        };

        var running = null;

        //Init
        (function () {
            //loadChat();
        })();

        // $rootScope.$on('heartbeat-pulse', function (event, args) {
        //     if (service.messages != null) {
        //         updateChat();
        //     } else {
        //         loadChat();
        //     }
        // });

        return service;

        

        function loadChat(loadprevious) {
            loadprevious = loadprevious || false;
            if (running !== null) {
                return running;
            }
                        
            if (service.loadedInterval === null) {
                service.loadedInterval = {
                    to: Date.NewDate(),
                    from: new Date((Date.NewDate()).getTime() - (24 * 60 * 60 * 1000)) //ayer
                };
            }
            else if (loadprevious) {
                service.loadedInterval.to = service.loadedInterval.from;
                service.loadedInterval.from = new Date(service.loadedInterval.from.getTime() - (24 * 60 * 60 * 1000));
            }
            else
            {
                return updateChat();
            }

            var deferred = $q.defer();
            running = deferred.promise;

            var request = {
                method: 'GET',
                url: endPoints.chat.getFleetMessages,
                params: { 'fromDate': service.loadedInterval.from, 'toDate': service.loadedInterval.to }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                var ids = processMessages(response.data.messages);
                service.version = response.data.version;
                running = null;
                deferred.resolve(response.data);
                if (ids.length > 0) {
                    service.ackReceived(ids);
                }
                updateNewMessagesList();
            },
            function (response) {
                running = null;
                service.loadedInterval = null;
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function updateChat() {
            if (service.messages === null) {
                return service.loadChat();
            }
            
            if (running !== null) {
                return running;
            }
            var deferred = $q.defer();
            running = deferred.promise;

            var request = {
                method: 'GET',
                url: endPoints.chat.getFleetUpdates,
                params: { 'version': service.version }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                var ids = processMessages(response.data.messages);
                service.version = response.data.version;
                running = null;
                deferred.resolve(response.data);
                if (ids.length > 0) {
                    service.ackReceived(ids);
                }
                
                updateNewMessagesList();
            },
            function (response) {
                running = null;
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function ackReceived(ids) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.chat.ackReceived,
                data: ids
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {                
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });

            return deferred.promise;
        }

        function markAsRead(ids) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.chat.markAsRead,
                data: ids
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {                
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function sendMessage(recipient, msg) {

            if (!msg) {
                return;
            }
            var message = {
                id: Math.random(),
                operatorId: recipient, 
                sentTime: null,
                deliveryTime: null,
                readTime: null,
                direction: 'OUT',
                message: msg
            };
            service.messages.push(message);

            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.chat.sendMessage,
                data: { messageText: msg, recipient: recipient }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                message.id = response.data.toString();
                deferred.resolve(response.data);
            },
            function (response) {
                service.messages.splice(service.messages.indexOf(message),1);
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function processMessages(messages) {
            if (service.messages === null) {
                service.messages = [];
            }
            var ids = [];
            for (var i = 0; i < messages.length; i++) {
                if (messages[i].deliveryTime === null && messages[i].direction === 'IN') {
                    ids.push(messages[i].id);
                }
                if (service.messages.find(function (cur, index, arr) {
                    if (service.messages[index].id === messages[i].id) {
                        service.messages[index] = messages[i];
                        return true;
                    }
                    return false;
                }) === undefined) {
                    service.messages.push(messages[i]);
                }


            }
            return ids;
        }

        function updateNewMessagesList() {
            var to = service.messages.length || 0;
            var processedOpMessages = {};
            for (var i = 0; i < to; i++) {
                if (service.messages[i].direction === 'IN') { 
                    var processedOp = processedOpMessages[service.messages[i].operatorId] || 
                        { unread:0 , lastTime: null};
                    if (service.messages[i].readTime === null) {
                        processedOp.unread = processedOp.unread + 1;
                    }
                    if ((processedOp.lastTime === null) || (processedOp.lastTime < service.messages[i].sentTime)) {
                        processedOp.lastTime = service.messages[i].sentTime;
                    }
                    processedOpMessages[service.messages[i].operatorId] = processedOp;
                }
            }
            service.operatorMessages = processedOpMessages;
        }

        function getNewMsgCount(){
            if(!service.messages){ return 0; }
            var to = service.messages.length || 0;
            var count = 0;
            for(var i = 0; i < to; i++){
                if (service.messages[i].direction === 'IN' && service.messages[i].readTime === null) {
                    count++;
                }
            }
            return count;
        }
    }
})();